import { Box, Stack } from "@mui/material"

import { useQuery } from "@tanstack/react-query"

import { AgentRow } from "./EntityPortfolioAgents"
import { getPortfolioAgent } from "@/api/portfolio-agents-api"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import { LoadingSkeletons } from "@/components/LoadingSkeletons"

export function SinglePortfolioAgent(props: { entityId: string }) {
  const { entityId } = props

  const { data: agent } = useQuery({
    queryKey: [`portfolio_agent`, entityId],
    enabled: !!entityId,
    queryFn: async () => {
      if (!entityId) throw new Error("Params missing")

      const result = await getPortfolioAgent(entityId)
      console.log("onSingleAgent", result)
      return result
    },
  })

  return (
    <Box>
      {!agent ? (
        <LoadingSkeletons />
      ) : (
        <Stack gap={1}>
          <ErrorBoundary key={agent.id} fallback={<>Something went wrong</>}>
            <AgentRow agent={agent} singleAgentView />
          </ErrorBoundary>
        </Stack>
      )}
    </Box>
  )
}
